import Vue from 'vue';
import Vuex from 'vuex';
import VueLocalStorage from 'vue-localstorage'

Vue.use(Vuex);
Vue.use(VueLocalStorage)

let state,
    //hashState,
    localStorageState

// default empty state
state = {
    key: 'value',
}

// state from browser local storage
localStorageState = Vue.localStorage.get(process.env.VUE_APP_STORE_KEY)
if(localStorageState)
{
    let newState = JSON.parse(localStorageState)
    Object.keys(newState).forEach(e => 
        {
            if(newState[e] && newState[e] != null)
            {
                state[e] = newState[e]
            }
        }
    )
    // cambia qui eventuali voci di defaulta dopo averle caricate da local storage
    //state.searchCounter = 0
    //state.token = ''
}

/*
// state from MD5 query string
hashState = (window.location.hash).match('[?&]' + 'state' + '=([^&]+)')
if(hashState)
{
    let newState = JSON.parse(window.atob(hashState[1]))
    Object.keys(newState).forEach(e => 
        {
            if(newState[e])
            {
                state[e] = newState[e]
            }
        }
    )
}
*/

export default new Vuex.Store({
    state: state,
    getters: {
        getKey(state)
        {
            return state.key
        },
    },
    mutations: {
        setKey(state,payload)
        {
            state.key = payload
        },
    },
});
